import type { Dispatch, GetState } from 'model/State';
import { Query } from 'redux-first-router';

export const ROUTE = 'mac/addon-licence-evaluation/ROUTE';

export const route = (addonKey: string, params?: Query) => ({
  type: ROUTE,
  payload: {
    addonKey,
  },
  meta: {
    query: params,
  },
});

export const routeIncludeParams = (addonKey: string) => (dispatch: Dispatch, getState: GetState) =>
  dispatch(route(addonKey, getState().location.query));
